import { FaqItem } from './type'

export const faqData: FaqItem[] = [
  {
    id: 2,
    question: 'How do I make a personalized book?',
    answer: 'It\'s simple! Browse our collection, choose a story your child will love, personalise the character with your child\'s name and appearance, and order a premium hardcover book delivered to your door.',
  },
  {
    id: 11,
    question: 'How does the AI personalisation work?',
    answer: 'Every one of our stories is built on a hand-crafted illustration system. When you add your child\'s name, age, and look, our AI renders a character that matches — and places them into every spread of the book as the hero of the story. For custom stories, the AI also writes the narrative from your prompt and illustrates every page in the art style you choose.',
  },
  {
    id: 12,
    question: 'Is the AI safe for children\'s content?',
    answer: 'Yes. Our AI is trained and constrained specifically for children\'s storybooks — every generated story is age-appropriate, kind, and reviewed against our content guidelines before it\'s printed. Nothing unexpected ever lands in your child\'s book.',
  },
  {
    id: 13,
    question: 'Can I edit what the AI generates?',
    answer: 'Absolutely. Every book comes with our full editor — rewrite any text, regenerate any illustration, rearrange spreads, or tweak the art style. You\'re in control of the final story before it prints.',
  },
  {
    id: 7,
    question: 'How do I contact PixieWorld?',
    answer: 'We\'d love to hear from you! You can reach our friendly customer support team at support@pixieworldstore.com. We typically respond within 24 hours. You can also connect with us on social media or visit our Help Center for instant answers to common questions.',
  },
]
